// extracted by mini-css-extract-plugin
export var bg = "service-module--bg--FmfSS";
export var bgdesktop = "service-module--bgdesktop--96TGe";
export var bgmobile = "service-module--bgmobile--lSkgm";
export var bgtablet = "service-module--bgtablet--V1z4V";
export var bgxl = "service-module--bgxl--mRUmK";
export var blurb = "service-module--blurb--JAlSj";
export var bottom = "service-module--bottom--syQR6";
export var callout = "service-module--callout--gWixP";
export var contentleft = "service-module--contentleft--Z+cMg";
export var heading = "service-module--heading--HF72I";
export var icon = "service-module--icon--jM2cy";
export var inner = "service-module--inner--LVeOU";
export var left = "service-module--left--k9mCr";
export var leftbottom = "service-module--leftbottom--M-Kck";
export var lefttop = "service-module--lefttop--03mRG";
export var link = "service-module--link--obk4u";
export var linkhover = "service-module--linkhover--D-3U2";
export var list = "service-module--list--YHT4x";
export var listitem = "service-module--listitem--YFUfw";
export var locationlist = "service-module--locationlist--ZYAAj";
export var logo = "service-module--logo--LQRS2";
export var logolink = "service-module--logolink--HyYoT";
export var request = "service-module--request--SHQLj";
export var right = "service-module--right--Uf6yj";
export var screenreader = "service-module--screenreader--XNkHk";
export var servicecontent = "service-module--servicecontent--xOjeb";
export var serviceheading = "service-module--serviceheading--YsKXc";
export var servicename = "service-module--servicename--dZaX3";
export var top = "service-module--top--A7j7p";